import BaseTaskRunner from '@powerednow/shared/modules/taskRunner/Base';
import '@powerednow/ext-sources/sdk/ext/packages/core/src/util/LocalStorage';
import Bluebird from 'bluebird';

const debugFactory = require('@powerednow/shared/modules/debug');

declare let fetch: any;
declare let AuthManager: any;
declare let Utils: any;
declare let Ext: any;

const config = require('config.js');

const sendErrorLogsDebug = debugFactory('taskRunner:sendErrorLogs');

const TEN_SECONDS = 1000 * 10;
const FIVE_SECONDS = 1000 * 5;
export default class SendErrorLogsTask extends BaseTaskRunner {
    protected interval = TEN_SECONDS;

    protected defaultBatchTime = FIVE_SECONDS;

    private storage = new Ext.util.LocalStorage({
        id: 'clientErrors',
    });

    private async sendErrorToServer(errorObject) {
        sendErrorLogsDebug('Sending error to server', errorObject);
        const loggedInCompany = AuthManager.getCompany();
        if (loggedInCompany) {
            errorObject.whitelabel_id = loggedInCompany.get('whitelabel_id');
        }
        const response = await fetch(`${config.SERVER_URL}api/interfaces/errors`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            headers: {
                'Content-Type': 'application/json',
                ...AuthManager.getAuthHeader(),
            },
            body: JSON.stringify(errorObject), // body data type must match "Content-Type" header
        });
        await response.json();
    }

    protected async task() {
        sendErrorLogsDebug(`Error logging task scheduled, Utils.isOnline: ${Utils.isOnline()}`);
        if (!Utils.isOnline()) {
            return;
        }
        const savedErrors = this.getStoredErrors();
        sendErrorLogsDebug('Number of errors to send', savedErrors.length);
        if (savedErrors.length > 0) {
            await Bluebird.map(savedErrors, async savedError => {
                try {
                    await this.sendErrorToServer(savedError);
                    const indexOfError = savedErrors.indexOf(savedError);
                    savedErrors.splice(indexOfError, 1);
                } catch (error) {
                    sendErrorLogsDebug('Couldn\'t send error', error);
                }
            }, { concurrency: 5 });
            sendErrorLogsDebug('Remaining errors to send', savedErrors.length);
            this.setStoredErrors(savedErrors);
        }
    }

    private getStoredErrors() {
        let errors = this.storage.getItem('items');
        if (!errors) {
            errors = [];
        } else {
            try {
                errors = JSON.parse(errors);
            } catch (e) {
                errors = [];
            }
        }
        return errors;
    }

    private setStoredErrors(errors) {
        this.storage.setItem('items', JSON.stringify(errors, Utils.objectUtils.getCircularReplacer()));
    }

    public publish(errorObject) {
        const errors = this.getStoredErrors();
        errors.push(errorObject);
        this.setStoredErrors(errors);
        this.scheduleTask(this.defaultBatchTime);
    }
}
